import { Box, Button, Divider, Drawer, Typography } from '@mui/material';
import MuiTextField from '@mui/material/TextField';
import { useQuery } from 'react-query';
import { useEffect, useMemo, useState } from 'react';
import { ordersGet } from 'api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import React from 'react';
import moment from 'moment';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { easepick, RangePlugin, AmpPlugin } from '@easepick/bundle';
import easepickCss from '@easepick/bundle/dist/index.css?resource';
import easepickDarkCss from '../easepick.css?resource';
let picker: easepick.Core | null = null;

export const Orders = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [selected, setSelected] = useState<any | null>(null);
  const [dateRange, setDateRange] = useState<{
    start: Date;
    end: Date;
  }>({
    start: moment().toDate(),
    end: moment().toDate(),
  });
  const [total, setTotal] = useState(1);

  useEffect(() => {
    picker = new easepick.create({
      element: document.getElementById('datepicker')!,
      plugins: [RangePlugin, AmpPlugin],
      css: [easepickCss, easepickDarkCss],
      zIndex: 1,
      //format: 'DD/MM/YYYY',
    });

    picker.setDateRange(dateRange.start, dateRange.end);
    picker.on('select', (e) => {
      const { start, end } = e.detail;

      setDateRange({
        start,
        end,
      });
    });

    return () => {
      picker?.destroy();
    };
  }, []);

  const CustomStatusBar = (props: any) => {
    return (
      <div className="ag-status-bar-center">
        <div className="ag-status-name-value ag-status-panel ag-status-panel-total-row-count">
          <span className="label">Total Rows</span>:&nbsp;
          <span className="ag-status-name-value-value">{props.total}</span>
        </div>
      </div>
    );
  };

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfOrganizationsResponse } = useQuery(
    'getUserAdminOfOrganizations',
    getUserAdminOfOrganizations,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfOrganizations = getUserAdminOfOrganizationsResponse!.data;

  const [selectedOrganizationId, setSelectedOrganizationId] = useState<number>(
    userAdminOfOrganizations[0]?.id,
  );
  */

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ['ordersGet', selectedOrganization?.id, dateRange],
    ordersGet(selectedOrganization?.id as number, dateRange),
    {
      enabled: !!selectedOrganization,
      refetchOnWindowFocus: false,
    },
  );
  const data: any = response?.data?.orders;

  const dateFormat = 'YYYY-MM-DD HH:mm';

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: 'createdAt',
        headerName: 'Time',
        sortable: true,
        flex: 0.5,
        minWidth: 162,
        valueFormatter: ({ data }) => {
          return moment(data.createdAt).format(dateFormat);
        },
      },
      {
        field: 'email',
        headerName: 'Email',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 1.5,
        minWidth: 200,
        filter: true,
      },
      {
        field: 'total',
        headerName: 'Total',
        headerClass: 'ag-narrow text-align-right',
        cellClass: 'ag-narrow text-align-right',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
      },
      {
        field: 'currency',
        headerName: 'Currency',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
      },
      {
        field: 'paid',
        headerName: 'Paid',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
        cellRenderer: ({ data }) => {
          return !!data.paid ? <DoneIcon /> : <CloseIcon />;
        },
      },
      {
        field: 'phone',
        headerName: 'Phone',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 140,
        filter: true,
      },
      {
        field: 'paymentMethod',
        headerName: 'Payment method',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
      },
      {
        field: 'paymentId',
        headerName: 'Payment ID',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 310,
        filter: true,
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  console.log('selected', selected);

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: '100vw', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit event' : 'Add event'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              <Box sx={{ mb: '20px' }}>
                <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                  Organization:{' '}
                </Typography>
                {selectedOrganization?.name}
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The event will not be deleted if it has sold tickets.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 0,
            flexGrow: 0,
            alignItems: 'center',
            gap: '5px 6px',
            minHeight: '56px',
            maxWidth: '100vw',
            flexWrap: 'wrap',
            padding: '8px 0 8px',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: '1.25rem',
            }}
          >
            Orders
          </Typography>
          <MuiTextField
            size="small"
            id="datepicker"
            sx={{
              ml: '6px',
              minWidth: '200px',
            }}
          />
          {/*
          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0.5 }} />
            Add new
          </Button>
          */}
          <Button
            color="primary"
            onClick={() => {
              setDateRange({
                start: moment().subtract(1, 'months').startOf('month').toDate(),
                end: moment().subtract(1, 'months').endOf('month').toDate(),
              });
              picker?.setDateRange(
                moment().subtract(1, 'months').startOf('month').toDate(),
                moment().subtract(1, 'months').endOf('month').toDate(),
              );
            }}
          >
            Last month
          </Button>
          {/*
          <Button
            color="primary"
            onClick={() => {
              setDateRange({
                start: moment().subtract(1, 'd').toDate(),
                end: moment().subtract(1, 'd').toDate(),
              });
              picker?.setDateRange(
                moment().subtract(1, 'd').toDate(),
                moment().subtract(1, 'd').toDate(),
              );
            }}
          >
            Yesterday
          </Button>
          */}
        </Box>
        <Box
          className="ag-theme-material"
          sx={{
            background: '#000',
            borderRadius: 0,
            margin: '0 -16px -16px',
            display: 'flex',
            overflow: 'hidden',
            flexGrow: 1,
            height: '100%',
            boxShadow:
              'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px',
          }}
        >
          <AgGridReact
            className="ag-pointer-row"
            rowData={rowData}
            pagination={true}
            floatingFiltersHeight={50}
            paginationAutoPageSize={true}
            columnDefs={columnDefs}
            frameworkComponents={{
              customStatusBar: CustomStatusBar,
            }}
            statusBar={{
              statusPanels: [
                {
                  statusPanel: 'customStatusBar',
                  align: 'center',
                  statusPanelParams: { total: total },
                },
              ],
            }}
            /*
            onRowClicked={({ data }) => {
              setSelected(data);
              setRightDrawerOpen(true);
            }}*/
          ></AgGridReact>
        </Box>
      </Box>
    </>
  );
};
